module.exports = require('./helpers/bundle-url').getBundleURL('dgt5F') + "portalink_solar_system_example.2cd6b5b4.png";